import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import './ProtectedAdmin.css';

const ProtectedAdmin = () => {
  const [verificando, setVerificando] = useState(true);
  const [autenticado, setAutenticado] = useState(false);
  const [showBanner, setShowBanner] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const checkSession = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_AUTH_ADMIN_URL}/check_session.php`,
          {
            method: 'GET',
            credentials: 'include'
          }
        );
        const data = await response.json();

        if (data.success && data.autenticado) {
          setAutenticado(true);
        } else {
          navigate('/panel_admin_login');
        }
      } catch (error) {
        console.error('Error verificando sesion admin:', error);
        navigate('/panel_admin_login');
      } finally {
        setVerificando(false);
      }
    };

    checkSession();
  }, [navigate]);

  useEffect(() => {
    if (!autenticado) return;
    window.history.pushState(null, '', window.location.href);
    const handlePopState = () => {
      window.history.pushState(null, '', window.location.href);
      setShowBanner(true);
    };
    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [autenticado, location.pathname]);

  const handleConfirmar = async () => {
    try {
      await fetch(`${process.env.REACT_APP_AUTH_ADMIN_URL}/logout.php`, {
        method: 'POST',
        credentials: 'include',
      });
    } catch (e) {
      console.error('Error al cerrar sesion admin:', e);
    }
    setShowBanner(false);
    window.location.href = '/panel_admin_login';
  };

  const handleCancelar = () => {
    setShowBanner(false);
  };

  if (verificando) {
    return <div className="pa-cargando">Verificando sesion...</div>;
  }

  if (!autenticado) {
    return null;
  }

  return (
    <>
      <Outlet />
      {showBanner && (
        <div className="pa-overlay">
          <div className="pa-banner">
            <div className="pa-banner-icono">{'\u26A0\uFE0F'}</div>
            <p className="pa-banner-titulo">{'\u00BFEst\u00E1s seguro que quieres salir?'}</p>
            <p className="pa-banner-subtexto">
              {'Se cerrar\u00E1 tu sesion y deberas volver a autenticarte para continuar.'}
            </p>
            <div className="pa-banner-botones">
              <button className="pa-btn-cancelar" onClick={handleCancelar}>
                Quedarme
              </button>
              <button className="pa-btn-confirmar" onClick={handleConfirmar}>
                {'S\u00ED, salir'}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProtectedAdmin;